<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(index)="row">
                        <span> {{ row.index + 1 }} </span>
                    </template>
                    <template v-slot:cell(nominativo)="{ item }">
                        <span>{{ item.nome }} {{ item.cognome }}</span>
                        <span style="display: block">({{ item.identificativo }})</span>
                    </template>
                    <template v-slot:cell(eta)="{ item }">
                        <span>{{ calcoloEta(item.dataNascita) }}</span>
                    </template>
                    <template v-slot:cell(email)="{ item }">
                        <span>{{ item.email }}</span>
                    </template>
                    <template v-slot:cell(camera)="{ item }">
                        <span class="sa-table-span-label-primary">Piano: {{ item.nomePiano }}</span>
                        <span class="sa-table-span-label-primary">Stanza: {{ item.nomeStanza }} </span>
                        <span class="sa-table-span-label-primary">Letto: {{ item.nomeLetto }}</span>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <!-- <b-container class="bv-example-row">
							<b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Cartella Ospite" @click="onEdit(row.item, row.index, $event.target)" class="mr-1 no-text">
								<b-icon icon="book" variant="outline-sucess"></b-icon>
							</b-button>
						</b-container> -->

                        <b-container class="bv-example-row">
                            <b-button v-b-tooltip.hover size="sm" variant="outline-success" title="Cartella Paziente" @click="onOpenSchedaPaziente(row.item)" class="mr-1 no-text">
                                <b-icon icon="book" variant="outline-sucess"></b-icon>
                            </b-button>
                            <b-button size="sm" v-b-tooltip.hover title="Cambio Posto Letto" variant="outline-success" @click="onClickRicovera(row.item)" class="mr-1 no-text">
                                <font-awesome-icon icon="bed" />
                            </b-button>
                            <!-- <b-button v-if="row.item.statoAttuale === 'RICOVERATO'" v-b-tooltip.hover size="sm" variant="outline-success" title="Registra Uscita" @click="onClickConfigurazionePresenzaUscite(row.item)">
                                <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                            </b-button> -->
                            <template v-if="row.item.statoAttuale === 'RICOVERATO'">
                                <b-button v-b-tooltip.hover size="sm" variant="outline-purple" title="Registra Uscita" @click="onClickPresenzaUscita(row.item)" class="mr-1">
                                    <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
                                </b-button>

                                <!-- DA DECOMMENTARE SE SI LAVORA SULLE USCITE -->
                                <!-- <b-button v-b-tooltip.hover size="sm" variant="outline-secondary" title="Gestisci Uscite" @click="onClickConfigurazionePresenzaUscite(row.item)">
                                    <font-awesome-icon :icon="['fas', 'cog']" />
                                </b-button> -->
                            </template>
                            <b-button v-else v-b-tooltip.hover size="sm" variant="outline-danger" title="Registra Entrata" @click="onClickPresenzaEntrata(row.item)" class="sa-icon-rotate">
                                <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                            </b-button>

                            <b-button v-b-tooltip.hover title="Stampa" size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" style="margin-right: 3px" @click="onClickStampa(row.item)">
                                <b-icon icon="printer"></b-icon>
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-invisible">
            <rsa-registrazione-entrate-uscite-modal-edit-component ref="cmpRsaRegistrazioneEntrateUsciteModalEdit" @onSave="onSavePresenza" @onClose="onClosePresenza" />
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <b-modal ref="mdlStampaReferto" size="xl" scrollable>
            <vue-pdf-embed ref="pdfVueEmbeded" :source="stampaReport" allowfullscreen></vue-pdf-embed>
            <template #modal-footer>
                <b-button size="sm" variant="outline-secondary" @click="onClickPrint()">
                    <b-icon icon="printer"></b-icon>
                    Stampa
                </b-button>
            </template>
        </b-modal>
        <rsa-assegna-posto-letto-modal-edit-component ref="cmpAccettazionePostiLettoModalEdit" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" />
    </div>
</template>

<script>
import axios from "axios";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import RsaRegistrazioneEntrateUsciteModalEditComponent from "./RsaRegistrazioneEntrateUsciteModalEditComponent.vue";
import RsaAssegnaPostoLettoModalEditComponent from "../../rsaaccettazione/components/RsaAssegnaPostoLettoModalEditComponent.vue";
export default {
    name: "RsaGestioneOspitiListComponent",
    mixins: [UtilityMixin],
    components: { RsaRegistrazioneEntrateUsciteModalEditComponent, VuePdfEmbed, RsaAssegnaPostoLettoModalEditComponent },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaospiti",
            pathResourceStampa: "/rsaprintdata/folder",
            // pathResource: "/ospiti",
            filtroGestioneOspiti: {},
            stampaReport: "",
            items: [],
            listKey: 0,
            fields: [
                {
                    label: "*",
                    key: "index",
                    thStyle: "width: 0.5rem",
                },
                {
                    label: "Numero Cartella",
                    key: "numero",
                },
                {
                    label: "Nominativo",
                    key: "nominativo",
                    sortable: true,
                },
                {
                    label: "Età",
                    key: "eta",
                },
                { label: "Numero telefono", key: "telefono" },
                {
                    label: "Email",
                    key: "email",
                },
                {
                    label: "Camera",
                    key: "camera",
                },
                { class: "sa-table-column-action-double", key: "actions", label: "" },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroGestioneOspiti"]) {
                me.filtroGestioneOspiti = JSON.parse(sessionStorage["filtroGestioneOspiti"]);
            }

            let link = process.env.VUE_APP_PATH_API + me.pathResource;
            me.filtroGestioneOspiti.page = me.currentPage;
            me.filtroGestioneOspiti.forPage = me.perPage;
            // if (me.filtroGestioneOspiti.idPresidio) {
            axios
                .get(link, { params: me.filtroGestioneOspiti })
                .then((response) => {
                    me.items = [];
                    me.rows = response.data.data.recordsNumber;
                    me.items = response.data.data.list;
                    me.listKey++;
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
            /*    } else {
                this.$emit("afterLoadData");
                this.$bvModal.msgBoxOk("Inserire Presidio", {
                    title: "ATTENZIONE",
                    size: "sm",
                    okVariant: "outline-danger",
                });
            } */
        },
        onClickPrint() {
            this.$refs.pdfVueEmbeded.print();
        },
        onClickStampa(item) {
            console.log(item.id);
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStampa;
            axios
                .get(link, { params: { idAccettazione: item.id } })
                .then((response) => {
                    me.stampaReport = "data:application/pdf;base64," + response.data.data;
                    me.$refs.mdlStampaReferto.show();
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        onEdit(item) {
            let me = this;
            me.$router.push("/rsagestioneospiti/schedaospite/view/" + item.id);
        },
        onOpenSchedaPaziente(item) {
            let me = this;
            me.$router.push("/rsapaziente/view/" + item.id);
        },
        /* onClickPresenzaEntrata(item) {
            let me = this;
            console.log("onClickPresenzaEntrata", item);
            me.$refs.cmpRsaSchedaOspiteUsciteList.onClickAggiorna(item.id, item.statoAttuale);
        }, */

        onClickConfigurazionePresenzaUscite(item) {
            let me = this;
            me.$router.push("/rsapaziente/uscite" + "?idAccettazione=" + item.id);

            // console.log("onClickConfigurazionePresenzaUscite", item);
            // me.registraPresenza(item.id, 'USCITA');
        },
        onClickPresenzaUscita(item) {
            let me = this;
            me.$refs.cmpRsaRegistrazioneEntrateUsciteModalEdit.show(item, "USCITA");
            // console.log("ITEM: ", item);
        },
        onClickPresenzaEntrata(item) {
            let me = this;
            me.$refs.cmpRsaRegistrazioneEntrateUsciteModalEdit.show(item, "ENTRATA");
            // console.log("ITEM: ", item);
        },
        onSavePresenza() {
            let me = this;
            me.loadData();
        },
        onClosePresenza() {},
        resetList() {
            let me = this;
            me.items = [];
        },
        onClickRicovera(item) {
            let me = this;
            me.$refs.cmpAccettazionePostiLettoModalEdit.show(item);
        },
        onAfterLoadData() {
            let me = this;
            me.$emit("afterLoadData");
            me.loadData();
        },
        onBeforeLoadData() {
            let me = this;
            me.$emit("beforeLoadData");
        },
    },
};
</script>
<style></style>
